document.addEventListener('DOMContentLoaded', function () {

  const addToCartBtns = document.querySelectorAll('#add_to_cart');
  const buyNowBtn = document.querySelectorAll('#shop_buy_now');

  // Normal Add to Cart buttons
  addToCartBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.id;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(() => {
        refreshCart();

        const originalText = this.innerText;
        this.innerText = 'ADDED ✔';
        this.classList.add('added');

        setTimeout(() => {
          this.innerText = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Add to cart error:', error);
      });
    });
  });

  // BUY NOW button → Add to cart + redirect to checkout
  buyNowBtn.forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.id;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Buy now error:', error);
      });
    });
  });

}); // ✅ properly closes first DOMContentLoaded


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".first_linklist ul li").forEach(function (li) {
    li.addEventListener("mouseover", function () {
      let value = this.getAttribute("data-img");
      let img = this.closest(".link-list")
        ?.querySelector("li.mega-link.has-promotion img");

      if (img && value && value.trim() !== "") {
        img.src = value;
        img.srcset = value;
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
    const btn = document.getElementById("CheckOut");

    if (btn) {
        btn.addEventListener("click", function () {
            window.location.href = "/checkout";
        });
    }
});
